import React, { useState, useEffect } from 'react';
import appointmentService from '../services/appointmentService';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;
const getHeaders = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const TYPE_OPTIONS     = [{ value: 'firma', label: 'Firma' }, { value: 'consulta', label: 'Consulta' }, { value: 'entrega', label: 'Entrega' }, { value: 'seguimiento', label: 'Seguimiento' }, { value: 'interno', label: 'Interno' }];
const LOCATION_OPTIONS = [{ value: 'oficina', label: 'Oficina' }, { value: 'domicilio_cliente', label: 'Domicilio del cliente' }, { value: 'otro', label: 'Otro' }];

const inputSt  = { width: '100%', padding: '8px 12px', border: '1.5px solid #E5E7EB', borderRadius: 8, fontSize: 13, color: '#111827', backgroundColor: '#fff', outline: 'none', fontFamily: 'inherit', transition: 'border-color 0.15s' };
const selectSt = { ...inputSt, cursor: 'pointer' };

const focusSt = e => { e.target.style.borderColor = '#4F63D2'; e.target.style.boxShadow = '0 0 0 3px rgba(79,99,210,0.1)'; };
const blurSt  = e => { e.target.style.borderColor = '#E5E7EB'; e.target.style.boxShadow = 'none'; };

const Field = ({ label, required, children }) => (
  <div style={{ marginBottom: 14 }}>
    <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 5 }}>
      {label} {required && <span style={{ color: '#EF4444' }}>*</span>}
    </label>
    {children}
  </div>
);

function toLocalDatetimeValue(str) {
  if (!str) return '';
  const d = new Date(str);
  const p = n => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export default function AppointmentModal({ appointment, preselectedDate, onClose, onSaved, prefillClientId, prefillCaseFileId }) {
  const isEditing = !!appointment;

  const defaultStart = preselectedDate ? toLocalDatetimeValue(preselectedDate.toISOString()) : '';
  const defaultEnd = preselectedDate ? (() => {
    const e = new Date(preselectedDate); e.setHours(e.getHours() + 1);
    return toLocalDatetimeValue(e.toISOString());
  })() : '';

  const [form, setForm] = useState({
    title: '', type: 'consulta', status: 'programada',
    start_datetime: defaultStart, end_datetime: defaultEnd,
    location: 'oficina', user_id: '',
    client_id: prefillClientId || '', case_file_id: prefillCaseFileId || '', notes: '',
  });

  const [users, setUsers]       = useState([]);
  const [clients, setClients]   = useState([]);
  const [caseFiles, setCaseFiles] = useState([]);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState('');

  useEffect(() => {
    axios.get(`${API}/users`, getHeaders()).then(r => setUsers(r.data.data || r.data)).catch(() => {});
    axios.get(`${API}/clients?per_page=200`, getHeaders()).then(r => setClients(r.data.data || r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (form.client_id) {
      axios.get(`${API}/case-files?client_id=${form.client_id}&per_page=100`, getHeaders())
        .then(r => setCaseFiles(r.data.data || r.data)).catch(() => setCaseFiles([]));
    } else { setCaseFiles([]); setForm(f => ({ ...f, case_file_id: '' })); }
  }, [form.client_id]);

  useEffect(() => {
    if (appointment) {
      setForm({ title: appointment.title || '', type: appointment.type || 'consulta', status: appointment.status || 'programada', start_datetime: toLocalDatetimeValue(appointment.start_datetime), end_datetime: toLocalDatetimeValue(appointment.end_datetime), location: appointment.location || 'oficina', user_id: appointment.user_id || '', client_id: appointment.client_id || '', case_file_id: appointment.case_file_id || '', notes: appointment.notes || '' });
    }
  }, [appointment]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(f => {
      const updated = { ...f, [name]: value };
      if (name === 'start_datetime' && value) {
        const start = new Date(value);
        if (!isNaN(start)) {
          const end = new Date(start); end.setHours(end.getHours() + 1);
          const p = n => String(n).padStart(2, '0');
          updated.end_datetime = `${end.getFullYear()}-${p(end.getMonth()+1)}-${p(end.getDate())}T${p(end.getHours())}:${p(end.getMinutes())}`;
        }
      }
      return updated;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setSaving(true); setError('');
    try {
      if (isEditing) await appointmentService.update(appointment.id, form);
      else await appointmentService.create(form);
      onSaved();
    } catch (err) { setError(err.response?.data?.message || 'Error al guardar la cita'); }
    finally { setSaving(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(15,23,42,0.45)', backdropFilter: 'blur(2px)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ backgroundColor: '#fff', borderRadius: 14, boxShadow: '0 20px 60px rgba(0,0,0,0.18)', width: '100%', maxWidth: 640, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 22px', borderBottom: '1px solid #F3F4F6', flexShrink: 0 }}>
          <h5 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#111827' }}>{isEditing ? 'Editar cita' : 'Nueva cita'}</h5>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF', fontSize: 20, lineHeight: 1, padding: 2 }}>✕</button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} style={{ flex: 1, overflowY: 'auto', padding: '18px 22px' }}>
          {error && (
            <div style={{ padding: '10px 14px', borderRadius: 8, backgroundColor: '#FEE2E2', color: '#991B1B', fontSize: 13, marginBottom: 16 }}>{error}</div>
          )}

          <Field label="Título" required>
            <input name="title" value={form.title} onChange={handleChange} required placeholder="Ej: Firma de escritura" style={inputSt} onFocus={focusSt} onBlur={blurSt} />
          </Field>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0 14px' }}>
            <Field label="Tipo" required>
              <select name="type" value={form.type} onChange={handleChange} required style={selectSt} onFocus={focusSt} onBlur={blurSt}>
                {TYPE_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </Field>
            <Field label="Ubicación">
              <select name="location" value={form.location} onChange={handleChange} style={selectSt} onFocus={focusSt} onBlur={blurSt}>
                {LOCATION_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </Field>
            <Field label="Responsable" required>
              <select name="user_id" value={form.user_id} onChange={handleChange} required style={selectSt} onFocus={focusSt} onBlur={blurSt}>
                <option value="">Seleccionar...</option>
                {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
              </select>
            </Field>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 14px' }}>
            <Field label="Inicio" required>
              <input type="datetime-local" name="start_datetime" value={form.start_datetime} onChange={handleChange} required style={inputSt} onFocus={focusSt} onBlur={blurSt} />
            </Field>
            <Field label="Fin" required>
              <input type="datetime-local" name="end_datetime" value={form.end_datetime} onChange={handleChange} required style={inputSt} onFocus={focusSt} onBlur={blurSt} />
            </Field>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 14px' }}>
            <Field label="Cliente">
              <select name="client_id" value={form.client_id} onChange={handleChange} style={selectSt} onFocus={focusSt} onBlur={blurSt}>
                <option value="">Sin cliente</option>
                {clients.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </Field>
            <Field label="Expediente">
              <select name="case_file_id" value={form.case_file_id} onChange={handleChange} disabled={!form.client_id} style={{ ...selectSt, opacity: !form.client_id ? 0.5 : 1 }} onFocus={focusSt} onBlur={blurSt}>
                <option value="">Sin expediente</option>
                {caseFiles.map(cf => <option key={cf.id} value={cf.id}>#{cf.id} — {cf.matter || cf.title}</option>)}
              </select>
              {!form.client_id && <p style={{ margin: '3px 0 0', fontSize: 11, color: '#9CA3AF' }}>Selecciona un cliente primero</p>}
            </Field>
          </div>

          <Field label="Notas">
            <textarea name="notes" value={form.notes} onChange={handleChange} rows={3} placeholder="Observaciones adicionales..." style={{ ...inputSt, resize: 'vertical' }} onFocus={focusSt} onBlur={blurSt} />
          </Field>
        </form>

        {/* Footer */}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', padding: '14px 22px', borderTop: '1px solid #F3F4F6', flexShrink: 0 }}>
          <button type="button" onClick={onClose}
            style={{ padding: '8px 20px', borderRadius: 8, border: '1.5px solid #E5E7EB', backgroundColor: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#374151' }}>
            Cancelar
          </button>
          <button type="submit" disabled={saving} onClick={handleSubmit}
            style={{ padding: '8px 20px', borderRadius: 8, border: 'none', backgroundColor: '#4F63D2', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 600, opacity: saving ? 0.7 : 1 }}>
            {saving ? 'Guardando...' : isEditing ? 'Guardar cambios' : 'Crear cita'}
          </button>
        </div>
      </div>
    </div>
  );
}
